/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0 and the Server Side Public License, v 1; you may not use this file except
 * in compliance with, at your election, the Elastic License 2.0 or the Server
 * Side Public License, v 1.
 */

import React, { useState, createContext } from 'react';
import { DragDropContext } from 'react-beautiful-dnd';

// export interface EuiDragDropContextProps extends DragDropContextProps {}

export var EuiDragDropContextContext = /*#__PURE__*/createContext({
  isDraggingType: null
});
export var EuiDragDropContext = ({
  onBeforeDragStart,
  onDragStart,
  onDragUpdate,
  onDragEnd,
  children,
  ...rest
}) => {
  const [isDraggingType, setIsDraggingType] = useState(null);
  const euiOnDragStart = (start, provided) => {
    setIsDraggingType(start.type);
    if (onDragStart) {
      onDragStart(start, provided);
    }
  };
  const euiOnDragEnd = (result, provided) => {
    setIsDraggingType(null);
    if (onDragEnd) {
      onDragEnd(result, provided);
    }
  };
  return <DragDropContext onBeforeDragStart={onBeforeDragStart} onDragStart={euiOnDragStart} onDragUpdate={onDragUpdate} onDragEnd={euiOnDragEnd} {...rest}>
      <EuiDragDropContextContext.Provider value={{
      isDraggingType
    }}>
        {children}
      </EuiDragDropContextContext.Provider>
    </DragDropContext>;
};
try {
  EuiDragDropContext.__docgenInfo = {
    tags: {},
    filePath: '/app/src/components/drag_and_drop/drag_drop_context.tsx',
    description: '',
    displayName: 'EuiDragDropContext',
    methods: [],
    props: {
      onBeforeCapture: {
        defaultValue: null,
        description: '',
        name: 'onBeforeCapture',
        parent: {
          fileName: 'app/node_modules/@types/react-beautiful-dnd/index.d.ts',
          name: 'DragDropContextProps'
        },
        declarations: [{
          fileName: 'app/node_modules/@types/react-beautiful-dnd/index.d.ts',
          name: 'DragDropContextProps'
        }],
        required: false,
        type: {
          name: '(before: BeforeCapture) => void'
        }
      },
      onBeforeDragStart: {
        defaultValue: null,
        description: '',
        name: 'onBeforeDragStart',
        parent: {
          fileName: 'app/node_modules/@types/react-beautiful-dnd/index.d.ts',
          name: 'DragDropContextProps'
        },
        declarations: [{
          fileName: 'app/node_modules/@types/react-beautiful-dnd/index.d.ts',
          name: 'DragDropContextProps'
        }],
        required: false,
        type: {
          name: '(initial: DragStart) => void'
        }
      },
      onDragStart: {
        defaultValue: null,
        description: '',
        name: 'onDragStart',
        parent: {
          fileName: 'app/node_modules/@types/react-beautiful-dnd/index.d.ts',
          name: 'DragDropContextProps'
        },
        declarations: [{
          fileName: 'app/node_modules/@types/react-beautiful-dnd/index.d.ts',
          name: 'DragDropContextProps'
        }],
        required: false,
        type: {
          name: '(initial: DragStart, provided: ResponderProvided) => void'
        }
      },
      onDragUpdate: {
        defaultValue: null,
        description: '',
        name: 'onDragUpdate',
        parent: {
          fileName: 'app/node_modules/@types/react-beautiful-dnd/index.d.ts',
          name: 'DragDropContextProps'
        },
        declarations: [{
          fileName: 'app/node_modules/@types/react-beautiful-dnd/index.d.ts',
          name: 'DragDropContextProps'
        }],
        required: false,
        type: {
          name: '(initial: DragUpdate, provided: ResponderProvided) => void'
        }
      },
      onDragEnd: {
        defaultValue: null,
        description: '',
        name: 'onDragEnd',
        parent: {
          fileName: 'app/node_modules/@types/react-beautiful-dnd/index.d.ts',
          name: 'DragDropContextProps'
        },
        declarations: [{
          fileName: 'app/node_modules/@types/react-beautiful-dnd/index.d.ts',
          name: 'DragDropContextProps'
        }],
        required: true,
        type: {
          name: '(result: DropResult, provided: ResponderProvided) => void'
        }
      },
      dragHandleUsageInstructions: {
        defaultValue: null,
        description: '',
        name: 'dragHandleUsageInstructions',
        parent: {
          fileName: 'app/node_modules/@types/react-beautiful-dnd/index.d.ts',
          name: 'DragDropContextProps'
        },
        declarations: [{
          fileName: 'app/node_modules/@types/react-beautiful-dnd/index.d.ts',
          name: 'DragDropContextProps'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      nonce: {
        defaultValue: null,
        description: '',
        name: 'nonce',
        parent: {
          fileName: 'app/node_modules/@types/react-beautiful-dnd/index.d.ts',
          name: 'DragDropContextProps'
        },
        declarations: [{
          fileName: 'app/node_modules/@types/react-beautiful-dnd/index.d.ts',
          name: 'DragDropContextProps'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      enableDefaultSensors: {
        defaultValue: null,
        description: '',
        name: 'enableDefaultSensors',
        parent: {
          fileName: 'app/node_modules/@types/react-beautiful-dnd/index.d.ts',
          name: 'DragDropContextProps'
        },
        declarations: [{
          fileName: 'app/node_modules/@types/react-beautiful-dnd/index.d.ts',
          name: 'DragDropContextProps'
        }],
        required: false,
        type: {
          name: 'boolean'
        }
      },
      sensors: {
        defaultValue: null,
        description: '',
        name: 'sensors',
        parent: {
          fileName: 'app/node_modules/@types/react-beautiful-dnd/index.d.ts',
          name: 'DragDropContextProps'
        },
        declarations: [{
          fileName: 'app/node_modules/@types/react-beautiful-dnd/index.d.ts',
          name: 'DragDropContextProps'
        }],
        required: false,
        type: {
          name: 'Sensor[]'
        }
      }
    },
    extendedInterfaces: []
  };
} catch (e) {}